document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const modelViewers = document.querySelectorAll('model-viewer');
    modelViewers.forEach(function(viewer) {
      viewer.setAttribute('camera-orbit', '0deg 75deg 105%');
      viewer.setAttribute('min-camera-orbit', 'auto auto 5%');
      viewer.setAttribute('max-camera-orbit', 'auto auto 200%');
    });
  }, 1000);
});
